import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { NitroIcon, NitroParagraph } from 'nitro-components';
import Container from '../../../../../components/layouts/Container';

const NitroParagraphExtended = styled(NitroParagraph)`
  && {
    overflow-y: auto;
  }
`;

const Header = styled.div`
  background-color: ${props => props.theme.color.secondary};
  height: 300px;
  overflow: hidden;
`;

const BackgroundIcon = styled.div`
  position: absolute;
  left: 0;
  top: 50px;
  opacity: 0.05;
  z-index: 1;
`;

const ContentContainer = styled(Container)`
  position: relative;
`;

const HeaderContent = styled.div`
  height: 300px;
  width: 750px;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const EditButtonWrapper = styled.button`
  border: 0;
  outline: 0;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  height: 40px;
  width: 40px;
  border-radius: 4px;

  background-color: rgba(255, 255, 255, 0.1);
  :hover {
    background-color: rgba(255, 255, 255, 0.05);
  }
`;

const ReportHeader = ({ reportName, reportDescription, editAction }) => {
  return (
    <Header>
      <ContentContainer>
        <BackgroundIcon>
          <NitroIcon
            name="clip-board"
            variant="white"
            opacity={0.05}
            size={300}
          />
        </BackgroundIcon>
        <EditButtonWrapper onClick={editAction}>
          <NitroIcon name="edit" variant="white" size={14} />
        </EditButtonWrapper>
        <HeaderContent>
          <NitroParagraph noMargin size="30" variant="white" align="center">
            {reportName}
          </NitroParagraph>
          <NitroParagraphExtended variant="white" size="2" align="center">
            {reportDescription}
          </NitroParagraphExtended>
        </HeaderContent>
      </ContentContainer>
    </Header>
  );
};

ReportHeader.propTypes = {
  reportName: PropTypes.string,
  reportDescription: PropTypes.string,
  editAction: PropTypes.func,
};

export default ReportHeader;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Summary/Sections/ReportHeader.js